import React, {Fragment, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SelectCreator from "../../components/Forms/components/SelectCreator";
import InputCreator from "../../components/Forms/components/InputCreator";
import ZeusButton from "../../components/Button";
import Loader from "../../components/Loader";
import {
  requestDataExplorerSnapshot,
  saveDataExplorerSnapshot,
} from "../../redux/Actions/data-explorer.actions";
import {getDataExplorerSnapshots} from "../../redux/Selectors/data-explorer.selectors";
import {toast} from "react-toastify";

const SaveCell = (props) => {
  const {inputSensor, inputSensor2, open, sensor, template, toggle} = props;

  const dispatch = useDispatch();
  const snapshots = useSelector(getDataExplorerSnapshots);
  const [payload, setPayload] = useState({name: ""});

  useEffect(() => {
    const callback = (options) => {
      if (options.length > 0) {
        setPayload((prev) => ({
          ...prev,
          snapshot: options[0].value,
        }));
      }
    };
    dispatch(requestDataExplorerSnapshot(callback));
  }, [dispatch]);

  const handleInputChange = (event) => {
    const {value, name} = event.target;
    setPayload((prev) => ({...prev, [name]: value}));
  };

  const handleSave = () => {
    if (payload.name && payload.snapshot) {
      const requestPayload = {
        id: payload.snapshot,
        method: template,
        name: payload.name,
        sensor_id: sensor.id,
      };
      if (template === "dual_graph") {
        requestPayload.input_id = inputSensor;
      }
      if (template === "triple_graph") {
        requestPayload.input_ids = [inputSensor, inputSensor2];
      }
      dispatch(saveDataExplorerSnapshot(requestPayload, toggle));
    } else {
      toast.error("Please check required fields.");
    }
  };

  return (
    <Fragment>
      <Modal unmountOnClose={true} isOpen={open} toggle={toggle}>
        <Loader />
        <ModalHeader toggle={toggle}>Save As</ModalHeader>
        <ModalBody>
          <SelectCreator
            label="Target Snapshot"
            id="snapshot"
            name="snapshot"
            value={payload.snapshot}
            placeholder={"Choose a snapshot"}
            options={snapshots}
            onChange={handleInputChange}
            isRequired
            isSearchable
            large
          />
          <InputCreator
            data-cy="cell-name"
            label="Cell Name"
            id="name"
            name="name"
            placeholder={"Add a cell name"}
            isRequired
            onChange={handleInputChange}
            large
            value={payload.name}
          />
        </ModalBody>
        <ModalFooter>
          <ZeusButton onClick={handleSave} data-cy={"submit-btn"}>
            Save
          </ZeusButton>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

SaveCell.propTypes = {
  inputSensor: PropTypes.number,
  inputSensor2: PropTypes.number,
  open: PropTypes.bool,
  sensor: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  template: PropTypes.string.isRequired,
};

export default SaveCell;
